import { getEmployees } from '../../../services/register_redux/register_actions/Employee.action';
import { getSalaryRegister } from '../../../services/register_redux/register_actions/Salary_register.action';
import { getCtcMaster } from '../../../services/register_redux/register_actions/CtcMaster.action';
import { getSalaryAdvances } from '../../../services/register_redux/register_actions/SalaryAdvance.action';
import { getOtherInputs } from '../../../services/register_redux/register_actions/OtherInputs.action';
import { getLeaveRegister } from '../../../services/register_redux/register_actions/Leave_register.action';
import { getAttendanceRegisterOverride } from '../../../services/register_redux/register_actions/AttendanceRegisterOverride.action';
import {getMaternityBenefits} from '../../../services/register_redux/register_actions/MaternityBenefits.action';
import {getTn_form_VI} from '../../../services/register_redux/register_actions/Tn_form_VI.action';
import {getEmp_Separation} from '../../../services/register_redux/register_actions/Emp_Separation.action';
import {getContractors} from '../../../services/register_redux/register_actions/Contractor.action';
import {fetchleaveOpeningBalance} from '../../../services/register_redux/register_actions/Leave_opening_balance.action'
import {
    getReportsOfEmployeeBranchTransferAction,
    getEmployeeImportantBackupReportAction,
} from '../../../services/register_redux/register_actions/Employee.action';

import { getClientImportantBackupAction } from '../../../services/global_redux/globale_actions/Client.action';
import { getUnitImportantBackupAction } from '../../../services/global_redux/globale_actions/Unit.action';
import mainicon_Contractor from "../../../assets/register_assets/inputMatix/Staffing_Agencies/mainicon_Contractor.png"
import mainicon_LOP from "../../../assets/register_assets/inputMatix/Leave_opening_balance/mainicon_LOP.png"

import mainicon_TN from "../../../assets/register_assets/inputMatix/TN_Form/mainicon_TN.png"
import mainicon_Emp_separation from "../../../assets/register_assets/inputMatix/Employee_Separation/mainicon_Emp_separation.png"

import mainicon_attendanceoverride from "../../../assets/register_assets/inputMatix/Attendance Override/mainicon_attendanceoverride.png"
import mainicon_maternity from "../../../assets/register_assets/inputMatix/Maternity_Benefits/mainicon_maternity.png"

import mainicon_leave from "../../../assets/register_assets/inputMatix/Leave_Register/mainicon_leave.png"
import main_icon_other from "../../../assets/register_assets/inputMatix/Other_inputs/main_icon_other.png"

import mainicon from "../../../assets/register_assets/inputMatix/Salary_Advance/mainicon.png"

import ctc_master_icon from "../../../assets/register_assets/inputMatix/ctc_master_icon.png"

import empMasterIcon from '../../../assets/register_assets/inputMatix/emp_master_icon.png';
import salaryRegisterIcon from '../../../assets/register_assets/inputMatix/Salary_register/mainicon.png';
import {
    EMPLOYEE_MASTER_REPORT_COLUMNS,
    SALARY_REGISTER_REPORT_COLUMNS,
    CTC_MASTER_REPORT_COLUMNS,
    SALARY_ADVANCES_REPORT_COLUMNS,
    OTHER_INPUTS_REPORT_COLUMNS,
    Leave_Register_REPORT_COLUMNS,
    ATTENDANCE_OVERRIDE_COLUMNS,
    MATERNITY_BENEFITS_COLUMNS,
    TN_FORM_VI_COLUMNS,
    EMPLOYEE_SEPARATION_REPORT_COLUMNS,
    STAFFING_AGENCIES_REPORT_COLUMNS,
    LEAVE_OPENING_BALANCE_REPORT_COLUMNS,
    EMPLOYEE_TRANSFER_REPORT_COLUMNS,
    CLIENT_BACKUP_REPORT_COLUMNS,
    UNIT_BACKUP_REPORT_COLUMNS,
} from './reportColumns';

/** @typedef {{ key: string, label: string }} ReportColumnDef */

/**
 * @typedef {Object} ReportRegistryEntry
 * @property {string} id
 * @property {string} title
 * @property {string} icon
 * @property {string} iconColor
 * @property {ReportColumnDef[]} columns
 * @property {string} loadErrorMessage
 * @property {(dispatch: Function, date: string, clientId: string) => Promise<{success?: boolean, data?: unknown[], message?: string}>} [fetch]
 * @property {(dispatch: Function, date: string, clientId: string) => Promise<{success?: boolean, message?: string, rows?: object[], columns?: {key: string, label: string}[]}>} [fetchDynamic]
 * @property {boolean} [payrollMonthFilter]
 */

/** Add new reports here — copy an entry and wire fetch + columns. */
export const REPORT_REGISTRY = {
    'employee-master': {
        id: 'employee-master',
        title: 'Employee Master',
        icon: empMasterIcon,
        iconColor: '#0057ff',
        columns: EMPLOYEE_MASTER_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load employee master report',
        payrollMonthFilter: true,
        fetch: (dispatch, date, clientId) => dispatch(getEmployees(date, clientId)),
    },
    'salary-register': {
        id: 'salary-register',
        title: 'Salary Register',
        icon: salaryRegisterIcon,
        iconColor: '#fec53d',
        columns: SALARY_REGISTER_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load salary register report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getSalaryRegister(date)),
    },
    'ctc-master': {
        id: 'ctc-master',
        title: 'CTC Master',
        icon: ctc_master_icon,
        iconColor: '#4ad991',
        columns: CTC_MASTER_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load CTC Master report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getCtcMaster(date)),
    },
    'salary-advances': {
        id: 'salary-advances',
        title: 'Salary Advance',
        icon: mainicon,
        iconColor: '#7800c3',
        columns: SALARY_ADVANCES_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Salary Advance report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getSalaryAdvances(date)),
    },
    'other-inputs': {
        id: 'other-inputs',
        title: 'Other Inputs',
        icon: main_icon_other,
        iconColor: '#16b9f9',
        columns: OTHER_INPUTS_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Other Inputs report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getOtherInputs(date)),
    },
    'leave-register': {
        id: 'leave-register',
        title: 'Leave Register',
        icon: mainicon_leave,
        iconColor: '#8280ff',
        columns: Leave_Register_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Leave register report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getLeaveRegister(date)),
    },
    'attendance-override': {
        id: 'attendance-override',
        title: 'Attendance Override',
        icon: mainicon_attendanceoverride,
        iconColor: '#8280ff',
        columns: ATTENDANCE_OVERRIDE_COLUMNS,
        loadErrorMessage: 'Failed to load Attendance Override report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getAttendanceRegisterOverride(date)),
    },
    'maternity-benefits': {
        id: 'maternity-benefits',
        title: 'Maternity Benefits',
        icon: mainicon_maternity,
        iconColor: '#bd0084',
        columns: MATERNITY_BENEFITS_COLUMNS,
        loadErrorMessage: 'Failed to load Maternity Benefits report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getMaternityBenefits(date)),
    },
    'tamil-nadu-form-vi': {
        id: 'tamil-nadu-form-vi',
        title: 'TN Form VI',
        icon: mainicon_TN,
        iconColor: '#d80000',
        columns: TN_FORM_VI_COLUMNS,
        loadErrorMessage: 'Failed to load TN Form VI report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getTn_form_VI(date)),
    },
    'emp-separation': {
        id: 'emp-separation',
        title: 'Employee Separation',
        icon: mainicon_Emp_separation,
        iconColor: '#81cb00',
        columns: EMPLOYEE_SEPARATION_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Employee Separation report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getEmp_Separation(date)),
    },
    'contractor': {
        id: 'contractor',
        title: 'Staffing Agencies',
        icon: mainicon_Contractor,
        iconColor: '#81cb00',
        columns: STAFFING_AGENCIES_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Staffing Agencies report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(getContractors(date)),
    },
    'leave-opening-balance': {
        id: 'leave-opening-balance',
        title: 'Leave Opening Balance',
        icon: mainicon_LOP,
        iconColor: '#81cb00',
        columns: LEAVE_OPENING_BALANCE_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Leave Opening Balance report',
        payrollMonthFilter: true,
        fetch: (dispatch, date) => dispatch(fetchleaveOpeningBalance(date)),
    },
    'employee-transfer': {
        id: 'employee-transfer',
        title: 'Employee Transfer Detials',
        icon: empMasterIcon,
        iconColor: '#0057ff',
        columns: EMPLOYEE_TRANSFER_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load employee master report',
        payrollMonthFilter: true,
        fetch: (dispatch, date, clientId) =>
            dispatch(getReportsOfEmployeeBranchTransferAction(
                date,
                clientId,
                sessionStorage.getItem('selectedUnit')
            )),
    },
    'employee-master-updates': {
        id: 'employee-master-updates',
        title: 'Employee Backup Updates',
        icon: empMasterIcon,
        iconColor: '#0057ff',
        columns: EMPLOYEE_MASTER_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load employee master updates report',
        payrollMonthFilter: true,
        fetch: (dispatch, date, clientId) =>
            dispatch(getEmployeeImportantBackupReportAction(
                date,
                clientId,
                sessionStorage.getItem('selectedUnit')
            )),
    },
    'attendance-register': {
        id: 'attendance-register',
        title: 'Attendance Register',
        icon: mainicon_leave,
        iconColor: '#8280ff',
        columns: [],
        loadErrorMessage: 'Failed to load attendance register report',
        payrollMonthFilter: true,
    },
    'org-backup': {
        id: 'org-backup',
        title: 'Organization Backup Details',
        icon: ctc_master_icon,  // or a client icon
        iconColor: '#0057ff',
        columns: CLIENT_BACKUP_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load organization backup report',
        payrollMonthFilter: true,
        fetch: (dispatch, date, clientId) =>
            dispatch(getClientImportantBackupAction(date, clientId)),
    },
    'branch-backup': {
        id: 'branch-backup',
        title: 'Branch Backup Details',
        icon: mainicon_leave,
        iconColor: '#0057ff',
        columns: UNIT_BACKUP_REPORT_COLUMNS,
        loadErrorMessage: 'Failed to load Branch backup report',
        payrollMonthFilter: true,
        fetch: (dispatch, date, clientId) =>
            dispatch(getUnitImportantBackupAction(date, clientId)),
    },
};

export const REGISTRY_REPORT_IDS = Object.keys(REPORT_REGISTRY);

export const MONTH_LOCKED_REPORT_IDS = [
    'salary-register',
    'attendance-register',
    'attendance-override',
];

export function isMonthLockedReport(reportId) {
    return MONTH_LOCKED_REPORT_IDS.includes(reportId);
}

export function isValidPayrollDate(value) {
    return /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(String(value || "").trim());
}

export function toPayrollMonthKey(value) {
    if (value == null || value === "") return "";
    const s = String(value).trim();
    if (s.toLowerCase() === "all" || s.includes("NaN")) return "";
    const iso = s.match(/^(\d{4})-(\d{2})(?:-\d{2})?/);
    if (iso) {
        const month = Number(iso[2]);
        if (month >= 1 && month <= 12) return `${iso[1]}-${iso[2]}-01`;
        return "";
    }
    const dt = new Date(s);
    if (Number.isNaN(dt.getTime())) return "";
    const year = dt.getFullYear();
    const month = dt.getMonth() + 1;
    if (!Number.isFinite(year) || year < 1900 || month < 1 || month > 12) return "";
    return `${year}-${String(month).padStart(2, "0")}-01`;
}

export function filterRowsByBranch(rows, unitId, reportId) {
    if (!Array.isArray(rows)) return [];
    const key = String(unitId || "").trim().toLowerCase();
    if (!key) return rows;
    if (reportId === "org-backup") return rows;
    if (reportId === "employee-transfer") {
        return rows.filter((row) => {
            const from = String(row?.from_unit_id || "").trim().toLowerCase();
            const to = String(row?.to_unit_id || "").trim().toLowerCase();
            return from === key || to === key;
        });
    }
    return rows.filter(
        (row) => String(row?.unit_id || "").trim().toLowerCase() === key
    );
}

/**
 * @param {string} reportTitle
 * @returns {ReportRegistryEntry | undefined}
 */
export function getReportRegistryEntry(reportTitle) {
    return REPORT_REGISTRY[reportTitle];
}

/**
 * @param {ReportColumnDef[]} columns
 * @returns {{ key: string, value: string }[]}
 */
export function columnsToTableHeader(columns) {
    return columns.map((col) => ({
        key: col.key,
        value: col.label || col.value,
    }));
}

/**
 * @param {Object} params
 * @param {ReportRegistryEntry} params.config
 * @param {Function} params.dispatch
 * @param {string} params.date
 * @param {string | null} params.clientId
 * @param {string | null} [params.unitId]
 * @param {Function} [params.setLoading]
 * @param {Function} params.setData
 * @param {Function} params.setHeader
 * @param {Function} [params.setAvailableYearMonths]
 * @param {Function} [params.setFilterType]
 * @param {Function} [params.showSnackbar]
 */
export async function loadRegistryReport({
    config,
    dispatch,
    date,
    clientId,
    unitId,
    setLoading,
    setData,
    setHeader,
    setAvailableYearMonths,
    setFilterType,
    showSnackbar,
}) {
    const emptyHeader = config.columns?.length ? config.columns : [];
    const payrollDate = isMonthLockedReport(config.id)
        ? toPayrollMonthKey(date)
        : (String(date || "").toLowerCase() === "all" ? "all" : (toPayrollMonthKey(date) || "all"));

    if (!clientId) {
        showSnackbar?.('Select organization to view report', 'warning');
        setData([]);
        setHeader(emptyHeader);
        return;
    }

    if (!unitId && config.id !== 'org-backup') {
        showSnackbar?.('Select branch to view report', 'warning');
        setData([]);
        setHeader(emptyHeader);
        return;
    }

    if (isMonthLockedReport(config.id) && !isValidPayrollDate(payrollDate)) {
        showSnackbar?.('Select a payroll month to view this report.', 'warning');
        setData([]);
        setHeader(emptyHeader);
        return;
    }

    setLoading?.(false);
    try {
        if (config.fetchDynamic) {
            const result = await config.fetchDynamic(dispatch, payrollDate, clientId);
            if (result?.success) {
                const raw = result.rows;
                const list = Array.isArray(raw)
                    ? raw
                    : Array.isArray(raw?.data)
                      ? raw.data
                      : [];
                setData(filterRowsByBranch(list, unitId, config.id));
                setHeader(Array.isArray(result.columns) ? result.columns : emptyHeader);
                setAvailableYearMonths?.(null);
                setFilterType?.('monthly');
            } else {
                showSnackbar?.(result?.message || config.loadErrorMessage, 'error');
                setData([]);
                setHeader(Array.isArray(result.columns) ? result.columns : emptyHeader);
            }
            return;
        }

        const response = await config.fetch(dispatch, payrollDate, clientId);
        if (response?.success) {
            const raw = response.data;
            const list = Array.isArray(raw)
                ? raw
                : Array.isArray(raw?.data)
                  ? raw.data
                  : Array.isArray(raw?.employees)
                    ? raw.employees
                    : [];
            const rows = filterRowsByBranch(list, unitId, config.id);
            setData(rows);
            setHeader(config.columns?.length ? config.columns : emptyHeader);
            setAvailableYearMonths?.(null);
            setFilterType?.('monthly');
        } else {
            showSnackbar?.(response?.message || config.loadErrorMessage, 'error');
            setData([]);
            setHeader(config.columns?.length ? config.columns : emptyHeader);
        }
    } catch (err) {
        console.error(`Failed to load report ${config.id}:`, err);
        showSnackbar?.(config.loadErrorMessage, 'error');
        setData([]);
        setHeader(emptyHeader);
    } finally {
        setLoading?.(false);
    }
}
